import { Megaphone, CalendarDays, MapPin, Star } from "lucide-react";

export default function Announcements() {
  const announcements = [
    {
      title: "Mass",    
      date: "November 24, 2025",
      venue: "SNSU Gym @ 7:00am",
      bg: "from-yellow-100 to-yellow-200",
      border: "border-orange-500",
      icon: <Star className="w-5 h-5 text-orange-600" />,
    },
        {
      title: "Parade",    
      date: "November 24, 2025",
      venue: "TBA @ 8:30am",
      bg: "from-yellow-100 to-yellow-200",
      border: "border-yellow-500",
      icon: <Star className="w-5 h-5 text-yellow-600" />,
    },
    {
      title: "Opening UIG 2025",    
      date: "November 24, 2025",
      venue: "Provincial Gym @ 10:00am-12:00nn",
      bg: "from-yellow-100 to-yellow-200",
      border: "border-green-500",
      icon: <Star className="w-5 h-5 text-green-600" />,
    },
    {
      title: "Basketball Men & Women",    
      date: "November 24-28, 2025",
      venue: "SNSU Gym @ 1:00pm-7:00pm",
      bg: "from-red-100 to-red-200",
      border: "border-red-500",
      icon: <Star className="w-5 h-5 text-red-600" />,
    },
      {
      title: "Volleyball Men & Women",    
      date: "November 25-28, 2025",
      venue: "SNSU Gym @ 7:30am-12:00nn",
      bg: "from-red-100 to-red-200",
      border: "border-red-500",
      icon: <Star className="w-5 h-5 text-red-600" />,
    },
    {
      title: "Arnis Men & Women",    
      date: "November 25-28, 2025",
      venue: "Provincial Gym @ 7:30am-12:00nn",
      bg: "from-red-100 to-red-200",
      border: "border-red-500",
      icon: <Star className="w-5 h-5 text-red-600" />,
    },
        {
      title: "Badminton Men & Women",    
      date: "November 24-26, 2025",
      venue: "Surigao River Badminton ",
      bg: "from-red-100 to-red-200",
      border: "border-red-500",
      icon: <Star className="w-5 h-5 text-red-600" />,
    },
    {
      title: "Table Tennis Men & Women",    
      date: "November 24-25, 2025",
      venue: "COT Room ",
      bg: "from-red-100 to-red-200",
      border: "border-red-500",
      icon: <Star className="w-5 h-5 text-red-600" />,
    },
        {
      title: "Chess Men & Women",    
      date: "November 24-25, 2025",
      venue: "Library ",
      bg: "from-red-100 to-red-200",
      border: "border-red-500",
      icon: <Star className="w-5 h-5 text-red-600" />,
    },
    {
      title: "Mobile Legend Men & Women",    
      date: "November 24-25, 2025",
      venue: "EB 4th Floor ",
      bg: "from-red-100 to-red-200",
      border: "border-red-500",
      icon: <Star className="w-5 h-5 text-red-600" />,
    },
    {
      title: "Lawn Tennis Men & Women",    
      date: "November 24-25, 2025",
      venue: "DPWH ",
      bg: "from-red-100 to-red-200",
      border: "border-red-500",
      icon: <Star className="w-5 h-5 text-red-600" />,
    },
    {
      title: "Tug of War Men & Women",    
      date: "November 24-25, 2025",
      venue: "Car Park (alongside Fitness Room) ",
      bg: "from-red-100 to-red-200",
      border: "border-red-500",
      icon: <Star className="w-5 h-5 text-red-600" />,
    },
        {
      title: "Sepak Takraw Men & Women",    
      date: "November 24-27, 2025",
      venue: "TBA",
      bg: "from-red-100 to-red-200",
      border: "border-red-500",
      icon: <Star className="w-5 h-5 text-red-600" />,
    },
        {
      title: "Visual Arts",    
      date: "November 24, 2025",
      venue: "Academic Hall @ 1:00pm-7:00pm ",
      bg: "from-green-100 to-green-200",
      border: "border-green-500",
      icon: <Star className="w-5 h-5 text-green-600" />,
    },
    {
      title: "Literary Festival",    
      date: "November 25, 2025",
      venue: "LRC @ 1:00pm-7:00pm",
      bg: "from-green-100 to-green-200",
      border: "border-grren-500",
      icon: <Star className="w-5 h-5 text-green-600" />,
    },
      {
      title: "Theater Festival",    
      date: "November 26, 2025",
      venue: "LRC @ 1:00pm-7:00pm",
      bg: "from-green-100 to-green-200",
      border: "border-grren-500",
      icon: <Star className="w-5 h-5 text-green-600" />,
    },
    {
      title: "Muscial Festival",    
      date: "November 27, 2025",
      venue: "Academic Hall @ 9:00am-12:0nn",
      bg: "from-green-100 to-green-200",
      border: "border-grren-500",
      icon: <Star className="w-5 h-5 text-green-600" />,
    },
      {
      title: "Dance Festival",    
      date: "November 27, 2025",
      venue: "Academic Hall @ 1:00pm-7:00pm",
      bg: "from-green-100 to-green-200",
      border: "border-grren-500",
      icon: <Star className="w-5 h-5 text-green-600" />,
    },
          {
      title: "Bench Yell",    
      date: "November 28, 2025",
      venue: "SNSU Gym @ 1:00pm-5:00pm",
      bg: "from-green-100 to-green-200",
      border: "border-grren-500",
      icon: <Star className="w-5 h-5 text-green-600" />,
    },
      {
      title: "Musical Festival",    
      date: "November 28, 2025",
      venue: "SNSU Gym @ 1:00pm-5:00pm",
      bg: "from-green-100 to-green-200",
      border: "border-grren-500",
      icon: <Star className="w-5 h-5 text-green-600" />,
    },
    {
      title: "Awarding Ceremony",
      date: "November 28, 2025",
      venue: "SNSU Gym @ 5:00pm",
      bg: "from-blue-100 to-blue-200",
      border: "border-blue-500",
      icon: <Megaphone className="w-5 h-5 text-blue-600" />,
    },
  ];

  return (
    <div className="p-6">
      {/* Header */}
      <div className="flex items-center gap-3 mb-6">
        <Megaphone className="w-8 h-8 text-blue-600" />
        <h1 className="text-3xl font-bold text-gray-800">Announcements</h1>
      </div>

      {/* Responsive scrollable list */}
      <div className="max-h-[60vh] overflow-y-auto pr-2 space-y-3">
        {announcements.map((item, index) => (
          <div
            key={index}
            className={`flex flex-wrap sm:flex-nowrap items-center gap-3 rounded-lg shadow-md border-l-4 ${item.border} 
              bg-gradient-to-r ${item.bg} p-3 hover:scale-[1.01] hover:shadow-lg transition-all duration-300`}
          >
            {item.icon}
            <span className="font-semibold text-gray-800">{item.title}</span>
            <span className="flex items-center gap-1 text-sm text-gray-700">
              <CalendarDays className="w-4 h-4" /> {item.date}
            </span>
            <span className="flex items-center gap-1 text-sm text-gray-700">
              <MapPin className="w-4 h-4" /> {item.venue}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
